import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

export default function CircularProgressWithLabel(props) {

  let percentageComplete = Math.round((props.completed_section / props.total_section)*100);

  return (
    <Box position="relative" display="inline-flex">
      <CircularProgress size = {55} variant="static" value={percentageComplete} style = {{color: '#ebd1d1'}} />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography variant="caption" component="div" color="textSecondary">{`${percentageComplete}%`}</Typography>
      </Box>
    </Box>
  );
}

CircularProgressWithLabel.propTypes = {
  total_section: PropTypes.number.isRequired,
  completed_section: PropTypes.number.isRequired
};

